import React from "react";
import "./Contact.css"

export default function Contact(props) {
    return <h1>Contact Component Hello</h1>
}